import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as Chart from 'chart.js';
import * as moment from 'moment';
import { ajax } from 'jquery';

@Component({
  selector: 'app-luminarias',
  templateUrl: './luminarias.component.html'
})
export class LuminariasComponent implements OnInit {
  infoActive:boolean = true;
  mapActive:boolean = false;
  listActive:boolean = false;
  latitude = 4.66125;
  longitude = -73.994817;
  zoom = 11;
  mapType;
  clientClass;
  PostesTabla:any[] = [];
  Style; 
  prueba1=300;
  prueba2=13;
  prueba3=2;
  prueba4=3000;
  prueba5=25;
  prueba6=432;
  prueba7=623;
  valorPrueba = 350313;
  setDiagram:boolean = false;
  isTable:boolean = false;
  safeHtml: SafeHtml;
  beneficiarys:any[] = [];
  floatOn:boolean;
  arrDispac:any[] = [];
  graphContent = [
    { titulo: 'PANEL SOLAR', imagen: '../../../assets/img/icons/common/svgEnergy/054-panel.svg' },
    { titulo: 'INVERSOR', imagen: '../../../assets/img/icons/common/svgEnergy/055-inversor.svg' },
    { titulo: 'SÁLIDA INSTALACIÓN', imagen: '../../../assets/img/icons/common/svgEnergy/056-salida.svg' },
    { titulo: 'CONTROLADOR', imagen: '../../../assets/img/icons/common/svgEnergy/042-gauge.svg' },
    { titulo: 'BATERÍA', imagen: '../../../assets/img/icons/common/svgEnergy/048-accumulator.svg' },
  ];
  dummyContent = [  
    { titulo: 'Luminarias instaladas', imagen: '<svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m256 216a88 88 0 1 0 -88-88 88.1 88.1 0 0 0 88 88zm0-160a72 72 0 1 1 -72 72 72.081 72.081 0 0 1 72-72z"/><path d="m256 32a8 8 0 0 0 8-8v-8a8 8 0 0 0 -16 0v8a8 8 0 0 0 8 8z"/><path d="m248 232v8a8 8 0 0 0 16 0v-8a8 8 0 0 0 -16 0z"/><path d="m360 136h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"/><path d="m144 136h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"/><path d="m329.539 62.461a7.976 7.976 0 0 0 5.657-2.343l5.657-5.657a8 8 0 1 0 -11.314-11.314l-5.657 5.653a8 8 0 0 0 5.657 13.657z"/><path d="m176.8 195.883-5.657 5.657a8 8 0 0 0 11.314 11.313l5.657-5.658a8 8 0 1 0 -11.314-11.312z"/><path d="m323.882 195.882a8 8 0 0 0 0 11.313l5.657 5.658a8 8 0 1 0 11.314-11.313l-5.657-5.657a8 8 0 0 0 -11.314-.001z"/><path d="m176.8 60.118a8 8 0 1 0 11.318-11.318l-5.657-5.657a8 8 0 0 0 -11.314 11.314z"/><path d="m496 464h-96v-32h64a8 8 0 0 0 8-8v-120a8 8 0 0 0 -8-8h-176a8 8 0 0 0 -8 8v120a8 8 0 0 0 8 8h64v32h-192v-32h64a8 8 0 0 0 8-8v-120a8 8 0 0 0 -8-8h-176a8 8 0 0 0 -8 8v120a8 8 0 0 0 8 8h64v32h-96a8 8 0 0 0 -8 8v24a8 8 0 0 0 8 8h480a8 8 0 0 0 8-8v-24a8 8 0 0 0 -8-8zm-160-48h-40v-24h40zm0-40h-40v-24h40zm0-40h-40v-24h40zm-240 80h-40v-24h40zm0-40h-40v-24h40zm0-40h-40v-24h40zm320-24h40v24h-40zm0 40h40v24h-40zm0 40h40v24h-40zm-64-80h48v24h-48zm0 40h48v24h-48zm0 40h48v24h-48zm32 40v32h-16v-32zm-208-120h40v24h-40zm0 40h40v24h-40zm0 40h40v24h-40zm-64-80h48v24h-48zm0 40h48v24h-48zm0 40h48v24h-48zm32 40v32h-16v-32zm344 56h-464v-8h464z"/></g></svg>' },
    { titulo: 'Hora de encendido', imagen: '<svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m352 80h-16v-48a24 24 0 0 0 -48 0v48h-64v-48a24 24 0 0 0 -48 0v48h-16a8 8 0 0 0 -8 8v152a48.051 48.051 0 0 0 48 48h16v24a8 8 0 0 0 8 8h8v176a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-176h8a8 8 0 0 0 8-8v-24h16a48.051 48.051 0 0 0 48-48v-152a8 8 0 0 0 -8-8zm-48-48a8 8 0 0 1 16 0v48h-16zm-112 0a8 8 0 0 1 16 0v48h-16zm72 456h-16v-168h16zm16-184h-48v-16h48zm64-64a32.036 32.036 0 0 1 -32 32h-112a32.036 32.036 0 0 1 -32-32v-112h176zm0-128h-176v-16h176z"/><path d="m271 184h-19.071l11.471-27.963a8 8 0 0 0 -14.8-6.074l-16 39a8 8 0 0 0 7.4 11.037h19.456l-10.946 29.191a8 8 0 1 0 14.98 5.618l15-40a8 8 0 0 0 -7.49-10.809z"/></g></svg>' },
    { titulo: 'Hora de apagado', imagen: '<svg id="Capa_1" enable-background="new 0 0 512.001 512.001" height="512" viewBox="0 0 512.001 512.001" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><g><path d="m511.81 254.05c-.836-4.117-4.233-7.335-8.389-7.94-4.158-.605-8.408 1.572-10.31 5.325-1.889 3.728-1.273 8.34 1.592 11.401 2.819 3.012 7.314 3.967 11.116 2.394 4.338-1.794 6.928-6.562 5.991-11.18z"/><path d="m499.644 291.64c-5.434-1.013-10.652 2.564-11.667 7.993-20.83 111.465-118.391 192.367-231.977 192.367-130.131 0-236-105.869-236-236s105.869-236 236-236c113.647 0 211.216 80.953 231.999 192.488 1.013 5.43 6.239 9.014 11.663 7.999 5.43-1.012 9.011-6.233 7.999-11.663-22.548-121-128.386-208.824-251.661-208.824-68.38 0-132.667 26.629-181.02 74.981-48.351 48.352-74.98 112.639-74.98 181.019s26.629 132.667 74.98 181.019c48.353 48.353 112.64 74.981 181.02 74.981 123.21 0 229.038-87.769 251.637-208.694 1.014-5.428-2.565-10.652-7.993-11.666z"/><path d="m256 74.453c22.829 0 45.081 4.179 66.14 12.421 5.145 2.014 10.943-.525 12.957-5.667 2.013-5.143-.524-10.944-5.668-12.957-23.391-9.154-48.096-13.797-73.429-13.797-111.134 0-201.547 90.414-201.547 201.547 0 46.805 15.846 91.171 44.999 126.977l-.623-.159c-5.355-1.371-10.798 1.861-12.166 7.211-1.368 5.351 1.86 10.797 7.211 12.166l36.859 9.425c.82.21 1.651.312 2.478.312 2.618 0 5.172-1.03 7.071-2.929 2.497-2.497 3.492-6.126 2.617-9.548l-9.426-36.859c-1.369-5.351-6.811-8.582-12.166-7.21-5.351 1.368-8.579 6.815-7.211 12.166l.646 2.527c-26.105-32.2-40.29-72.046-40.29-114.077.001-100.107 81.443-181.549 181.548-181.549z"/><path d="m187.969 445.774c21.789 7.813 44.679 11.773 68.031 11.773 111.134 0 201.547-90.414 201.547-201.547 0-27.98-5.628-55.068-16.727-80.513-7.33-16.803-16.8-32.356-28.273-46.464l.624.159c5.354 1.369 10.797-1.861 12.166-7.211 1.368-5.351-1.86-10.797-7.211-12.166l-36.859-9.425c-3.422-.874-7.051.119-9.549 2.618-2.497 2.497-3.492 6.126-2.617 9.548l9.426 36.859c1.156 4.52 5.222 7.525 9.682 7.525.819 0 1.653-.102 2.484-.314 5.351-1.368 8.579-6.815 7.211-12.165l-.655-2.563c26.132 32.169 40.299 71.925 40.299 114.113 0 100.105-81.441 181.547-181.547 181.547-21.046 0-41.664-3.566-61.281-10.6-5.195-1.862-10.924.838-12.788 6.038-1.866 5.198.838 10.924 6.037 12.788z"/><path d="m185.378 286.751h49.825v87.133c0 4.512 3.021 8.465 7.376 9.649.872.237 1.753.352 2.625.352 3.48 0 6.794-1.825 8.622-4.937l81.419-138.634c1.815-3.092 1.837-6.919.056-10.032-1.781-3.112-5.093-5.032-8.679-5.032h-49.825v-87.133c0-4.512-3.022-8.465-7.376-9.649-4.353-1.185-8.961.693-11.247 4.585l-81.419 138.634c-1.815 3.092-1.837 6.919-.056 10.032 1.781 3.112 5.093 5.032 8.679 5.032zm71.419-111.86v60.359c0 5.523 4.478 10 10 10h42.355l-53.949 91.86v-60.359c0-5.523-4.477-10-10-10h-42.355z"/></g></g></g></svg>' },
  ];
  totalEC;
  totalEG;
  totalCo2;
  totalArboles;
  co2;
  arboles;
  constructor(protected global: GlobalService,
              protected route: Router, 
              private spinner: NgxSpinnerService,
              private sanitizer: DomSanitizer, ) { 
               this.global.initData();
               this.CONSULTARINFORMACION();
              }

  ngOnInit(): void {
      this.clientClass = this.global.CLIENTDATALIWA[8];
      this.PostesTabla = this.global.PostesTabla;
      this.mapType = 'roadmap';
      this.Style = this.global.mapStyle;
      this.setDiagram = true;
  }

  CONSULTARINFORMACION(){
    try{ 
      const pdata1 = {option: 'postesli', idpro: 8};
    console.log(pdata1);
    ajax({data: pdata1,	cache: false,	dataType: 'json',	type:  'post',
    url: 'https://www.php.engenius.com.co/DatabasePruebas.php',
    success( data, textStatus, jQxhr ) {
    console.log('Datos Recibidos:', data);
    },
    error( jqXhr, textStatus, errorThrown ) {
    console.log(JSON.stringify(errorThrown));
    }
    }).then((response) => {

      setTimeout(() => {
        console.log('Postes', response);
        this.global.PostesTabla = response;
        this.isTable = true;
        
      }, 60);
    });

    }catch( error){
      console.log(error);
    }
    
  }

  isInfo(){
    if (this.infoActive == false) {
      this.infoActive = true;
      this.mapActive = false;
      this.listActive = false;
    } else {
      this.infoActive = false;
    }

  }
  isMap(){ 
    if (this.mapActive == false) {
      this.mapActive = true;
      this.infoActive = false;
      this.listActive = false;
    } else {
      this.mapActive = false;
    }
  }
  isList(){
    if (this.listActive == false) {
      this.listActive = true;
      this.mapActive = false;
      this.infoActive = false;
        $(function () {
        this.table = $('#userTicket').DataTable({
          'responsive': false,
          'destroy': true,
          'retrieve': true,
          'paging': true,
          'info': false,
          'pagingType': 'numbers',
          'language': {
            'url': '//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json'
          }
        });
      });
    } else {
      this.listActive = false;
      
    }

  }
  ver(data){
    console.log(data);
    this.global.bSetup = data;
    this.route.navigateByUrl('/p-luminaria');
  }
  IsActiveView(data){
    if(data == 'ON'){
      return 'ON';
    }
    if(data == 'OFF'){
      return 'OFF';
    }
  }
  isActiveBadge(data){
    if(data == 'ON'){
      return 'badge badge-success';
    }
    if(data == 'OFF'){
      return 'badge badge-danger';
    }
    this.ngOnInit();
  }
  sanitize(data: any) {
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(data);
    return this.safeHtml;
  }
}
